<template>
    <!-- is='' is determined in v-bind linkProperties, <a> or <router-link> -->
    <component v-bind="linkProperties()">
        <slot></slot>
    </component>
</template>

<script>
export default {
    name: 'GeneralLink',
    props: {
        isExternal: Boolean,
        openInNewTab: {
            type: Boolean,
            default: false
        },
        path: String
    },
    methods: {
        linkProperties() {
            if (this.isExternal) {
                return {
                    is: 'a',
                    href: this.path,
                    target: this.openInNewTab ? '_blank' : '_self'
                };
            }

            return {
                is: 'router-link',
                to: this.path
            };
        }
    }
};
</script>
